/*! RADA 4.0 — Trova la tua routine · Crea il tuo kit */
(function () {
  'use strict';
  var R = window.RADA || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (c) { return R.money ? R.money(c) : (c / 100).toFixed(2).replace('.', ',') + ' €'; };
  var esc = function (s) { return R.esc ? R.esc(s) : String(s == null ? '' : s); };
  var track = function (n, d) { if (R.track) R.track(n, d); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function routine() {
    try { var el = document.getElementById('rada-routine'); return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }
  function usable(p) { return p && p.available && p.variant && p.variant.available; }
  function planKey(pl) { return window.RADARoutine && window.RADARoutine.planKey ? window.RADARoutine.planKey(pl) : String(pl.opt || pl.name); }

  /* =========================================================
     Trova la tua routine
     ========================================================= */
  $$('[data-quiz]').forEach(function (root) {
    var form = $('[data-quiz-form]', root), out = $('[data-quiz-result]', root), bar = $('[data-quiz-bar]', root), back = $('[data-quiz-back]', root);
    var copy = {}; try { copy = JSON.parse($('[data-quiz-copy]', root).textContent); } catch (e) {}
    var qs = $$('[data-q]', root), step = 0, ans = {};

    function show(i) {
      step = i;
      qs.forEach(function (q, k) { q.hidden = k !== i; q.classList.toggle('is-on', k === i); });
      if (bar) bar.style.width = ((i) / qs.length * 100) + '%';
      if (back) back.hidden = i === 0;
      var f = $('input:checked', qs[i]) || $('input', qs[i]); if (f && i > 0) f.focus({ preventScroll: true });
    }

    function pick() {
      var cfg = routine(); if (!cfg) return null;
      var role = ans.q1 || 'kit';
      if (ans.q2 === 'full' && role !== 'kit' && usable(cfg.kit)) role = 'kit';
      var order = { kit: ['kit', 'shampoo', 'serum'], shampoo: ['shampoo', 'kit', 'serum'], serum: ['serum', 'kit', 'shampoo'] }[role];
      for (var i = 0; i < order.length; i++) if (usable(cfg[order[i]])) return { role: order[i], p: cfg[order[i]], wanted: role };
      return null;
    }

    function result() {
      var r = pick();
      form.hidden = true; out.hidden = false;
      if (bar) bar.style.width = '100%';
      if (!r) {
        out.innerHTML = '<p class="quiz-r-h">Nessun prodotto disponibile in questo momento.</p><a class="btn solid" href="' + esc((R.routes && R.routes.root ? R.routes.root : '/') + 'collections/all') + '">Vai allo shop</a>';
        return;
      }
      var p = r.p, plans = (p.variant.plans || []).slice(), wantSub = ans.q3 === 'sub' && plans.length > 0;
      var def = null;
      if (wantSub) { plans.forEach(function (pl) { if (!def && planKey(pl) === 'd45') def = pl; }); def = def || plans[0]; }
      var h = '<div class="quiz-r">';
      h += '<p class="eyb">La tua routine</p>';
      h += '<div class="quiz-r-card">';
      h += '<a class="quiz-r-img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" width="120" height="150">' : '') + '</a>';
      h += '<div><h3 class="quiz-r-h">' + esc(p.title) + '</h3>';
      if (copy.why && copy.why[r.role]) h += '<p class="quiz-r-why">' + esc(copy.why[r.role]) + '</p>';
      if (r.role !== r.wanted) h += '<p class="fine">Il prodotto più adatto alle tue risposte non è disponibile: ti proponiamo l\'alternativa più vicina.</p>';
      h += '<p class="quiz-r-p" data-quiz-price></p></div></div>';
      if (wantSub) {
        h += '<fieldset class="quiz-plans"><legend>' + esc(copy.club || 'Abbonamento') + ' · ricevilo ogni</legend><div class="chips">';
        plans.forEach(function (pl) {
          h += '<label class="chip"><input type="radio" name="quiz-plan" value="' + pl.id + '"' + (pl === def ? ' checked' : '') + '><span><b>' + esc(pl.opt || pl.name) + '</b><small>' + money(pl.price) + '</small></span></label>';
        });
        h += '</div></fieldset>';
      } else if (ans.q3 === 'sub') {
        h += '<p class="fine">L\'abbonamento non è ancora disponibile per questo prodotto: puoi acquistarlo singolarmente.</p>';
      }
      h += '<div class="quiz-r-a"><button class="btn solid" type="button" data-quiz-add>Aggiungi al carrello</button><a class="btn ghost" href="' + esc(p.url) + '">Vedi il prodotto</a></div>';
      h += '<button class="lk" type="button" data-quiz-restart>Rifai il test</button>';
      h += '</div>';
      out.innerHTML = h;

      function price() {
        var sel = $('input[name="quiz-plan"]:checked', out), pl = null;
        if (sel) plans.forEach(function (x) { if (String(x.id) === sel.value) pl = x; });
        var el = $('[data-quiz-price]', out);
        el.innerHTML = pl ? '<s>' + money(p.variant.price) + '</s> <b>' + money(pl.price) + '</b> <small>a consegna</small>' : '<b>' + money(p.variant.price) + '</b>';
        return pl;
      }
      price();
      out.addEventListener('change', price);
      $('[data-quiz-add]', out).addEventListener('click', function (e) {
        var btn = e.currentTarget, pl = price();
        var item = { id: p.variant.id, quantity: 1 }; if (pl) item.selling_plan = pl.id;
        btn.disabled = true; btn.classList.add('is-loading');
        (R.addItems ? R.addItems([item], { place: 'quiz', role: r.role }) : Promise.reject(new Error('Carrello non disponibile')))
          .catch(function (err) { if (R.cartMsg) R.cartMsg(err.message); })
          .then(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
      });
      $('[data-quiz-restart]', out).addEventListener('click', function () {
        ans = {}; form.reset(); out.hidden = true; out.innerHTML = ''; form.hidden = false; show(0);
        var f = $('input', qs[0]); if (f) f.focus();
      });
      out.focus({ preventScroll: false });
      track('quiz_result', { role: r.role, sub: !!wantSub });
    }

    form.addEventListener('change', function (e) {
      var t = e.target; if (!t.name) return;
      ans[t.name] = t.value;
      var i = qs.indexOf(t.closest('[data-q]'));
      setTimeout(function () { if (i < qs.length - 1) show(i + 1); else result(); }, reduce ? 0 : 220);
    });
    if (back) back.addEventListener('click', function () { if (step > 0) show(step - 1); });
    show(0);
  });

  /* =========================================================
     Crea il tuo kit
     ========================================================= */
  $$('[data-set]').forEach(function (root) {
    var min = +root.dataset.min || 1, label = root.dataset.label || 'Kit RADA';
    var items = $$('[data-set-item]', root), add = $('[data-set-add]', root), msg = $('[data-set-msg]', root);
    var state = {};
    function sync() {
      var n = 0, tot = 0;
      items.forEach(function (it) {
        var q = state[it.dataset.variant] || 0;
        n += q; tot += q * (+it.dataset.price);
        $('[data-set-qty]', it).textContent = q;
        $('[data-set-step="-1"]', it).disabled = q === 0;
        it.classList.toggle('is-on', q > 0);
      });
      $('[data-set-count]', root).textContent = n + (n === 1 ? ' prodotto' : ' prodotti');
      $('[data-set-total]', root).textContent = money(tot);
      var hint = $('[data-set-hint]', root);
      hint.textContent = n >= min ? 'Il tuo kit è pronto.' : 'Scegli ancora ' + (min - n) + (min - n === 1 ? ' prodotto.' : ' prodotti.');
      add.disabled = n < min;
      root.classList.toggle('is-ready', n >= min);
      kitHint(tot);
    }
    /* Se la selezione è esattamente shampoo + siero e il kit pronto costa meno, lo diciamo con chiarezza. */
    var cfg = routine(), kitBox = $('[data-set-kit]', root);
    function kitHint(tot) {
      if (!kitBox) return;
      var show = false;
      if (cfg && usable(cfg.kit) && cfg.shampoo && cfg.serum) {
        var sel = Object.keys(state).filter(function (k) { return state[k] > 0; });
        var sh = String(cfg.shampoo.variant.id), se = String(cfg.serum.variant.id);
        if (sel.length === 2 && state[sh] === 1 && state[se] === 1 && cfg.kit.variant.price < tot) {
          kitBox.innerHTML = 'Shampoo e siero sono già riuniti nel kit pronto: <b>' + money(cfg.kit.variant.price) + '</b> invece di ' + money(tot) + '. <a href="' + esc(cfg.kit.url) + '">Scopri il kit</a>';
          show = true;
        }
      }
      kitBox.hidden = !show;
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-set-step]'); if (!b) return;
      var it = b.closest('[data-set-item]'), id = it.dataset.variant;
      state[id] = Math.max(0, Math.min(9, (state[id] || 0) + (+b.dataset.setStep)));
      if (msg) msg.hidden = true;
      sync();
    });
    add.addEventListener('click', function () {
      var list = [];
      items.forEach(function (it) { var q = state[it.dataset.variant] || 0; if (q > 0) list.push({ id: +it.dataset.variant, quantity: q, properties: { _Kit: label } }); });
      if (!list.length) return;
      add.disabled = true; add.classList.add('is-loading');
      (R.addItems ? R.addItems(list, { place: 'build-your-set', count: list.length }) : Promise.reject(new Error('Carrello non disponibile')))
        .then(function () { state = {}; sync(); track('set_added', { lines: list.length }); })
        .catch(function (err) { if (msg) { msg.textContent = err.message; msg.hidden = false; } })
        .then(function () { add.classList.remove('is-loading'); sync(); });
    });
    sync();
  });
})();
